import React from 'react';
import { ColumnFlexBox } from '../../../../Components/FlexBox';
import { Divider, Typography } from '@mui/material';
import { formatListItemDate } from '../../../../Helpers/dates';
import CaptionValue from '../../../../Components/CaptionValue/CaptionValue';
import { useIntl } from 'react-intl';
import { formatThousands } from '../../../../Utils/constants/general';

const TooltipContent = function TooltipContent({
  tooltipData = [],
  colors = [],
}) {
  const intl = useIntl();

  return (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="240px">
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {formatListItemDate(tooltipData?.[0]?.rollingDate, true)?.split(',')[0]}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold',
          color: colors?.[0]
        }}>
        {intl.messages.REDEMPTION_AVERAGE}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold',
          color: colors?.[0]
        }}>
        {tooltipData?.[0]?.practices && tooltipData?.[0]?.answeredNum
          ? (
              (tooltipData?.[0]?.practices / tooltipData?.[0]?.answeredNum) *
              100
            )?.toFixed(2) + '%'
          : 0}
      </Typography>
      <CaptionValue
        key="practices"
        direction="row"
        width="100%"
        caption="PRACTICES"
        value={formatThousands(tooltipData?.[0]?.practices)}
        valueColor={colors?.[0]}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
      <CaptionValue
        key="answeredNum"
        direction="row"
        width="100%"
        caption="ANSWERED_CALLS"
        value={formatThousands(tooltipData?.[0]?.answeredNum)}
        valueColor={colors?.[0]}
        captionStyle={{ flexGrow: 1 }}
        valueStyle={{ fontWeight: 'bold' }}
        captionColor="#fff"
      />
      {tooltipData?.length > 1
        ? tooltipData?.slice(1)?.map((item, index) => (
            <React.Fragment key={index}>
              <Divider />
              <Typography
                variant="body1"
                sx={{
                  textAlign: "center",
                  fontWeight: 'bold',
                  color: colors?.[index + 1]
                }}>
                {item?.entity}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textAlign: "center",
                  fontWeight: 'bold',
                  color: colors?.[index + 1]
                }}>
                {item?.practices && item?.answeredNum
                  ? ((item?.practices / item?.answeredNum) * 100)?.toFixed(2) +
                    '%'
                  : 0}
              </Typography>
              <CaptionValue
                key={`practices-${index}`}
                direction="row"
                width="100%"
                caption="PRACTICES"
                value={formatThousands(item?.practices)}
                valueColor={colors?.[index + 1]}
                captionStyle={{ flexGrow: 1 }}
                valueStyle={{ fontWeight: 'bold' }}
                captionColor="#fff"
              />
              <CaptionValue
                key={`answeredNum-${index}`}
                direction="row"
                width="100%"
                caption="ANSWERED_CALLS"
                value={formatThousands(item?.answeredNum)}
                valueColor={colors?.[index + 1]}
                captionStyle={{ flexGrow: 1 }}
                valueStyle={{ fontWeight: 'bold' }}
                captionColor="#fff"
              />
            </React.Fragment>
          ))
        : null}
    </ColumnFlexBox>
  );
};

export default TooltipContent;
